import { render, staticRenderFns } from "./dictionary-card.vue?vue&type=template&id=0bcc0fb2&"
import script from "./dictionary-card.vue?vue&type=script&lang=ts&"
export * from "./dictionary-card.vue?vue&type=script&lang=ts&"
import style0 from "./dictionary-card.vue?vue&type=style&index=0&id=0bcc0fb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports